module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "form-control",
    attrs: {
      "name": _vm.name,
      "disabled": _vm.disabled
    },
    on: {
      "change": function($event) {
        _vm.value = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.formatted), function(item) {
    return _c('option', {
      domProps: {
        "value": item.val
      }
    }, [_vm._v(_vm._s(item.name))])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-9d5ea564!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/css/form/select.vue
// module id = 332
// module chunks = 2